module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Institution *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "abbreviation"
    }
  }, [_vm._v("Subdomain *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.domain),
      expression: "entity.domain"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "abbreviation",
      "type": "text",
      "placeholder": "Enter abbreviation"
    },
    domProps: {
      "value": (_vm.entity.domain)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "domain", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "localname"
    }
  }, [_vm._v("Institution Local Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.local_institution),
      expression: "entity.local_institution"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "localname",
      "type": "text",
      "placeholder": "Enter Institution Local Name"
    },
    domProps: {
      "value": (_vm.entity.local_institution)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "local_institution", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.type),
      expression: "entity.type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.typeOptions), function(value, key) {
    return _c('option', {
      key: value,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                      " + _vm._s(value) + "\n                    ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "library"
    }
  }, [_vm._v("Organisation Library")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.library),
      expression: "entity.library"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "library",
      "type": "text",
      "placeholder": "Enter Organisation Library"
    },
    domProps: {
      "value": (_vm.entity.library)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "library", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "country"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.country),
      expression: "entity.address.country"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "country",
      "type": "text",
      "placeholder": "Enter Country"
    },
    domProps: {
      "value": (_vm.entity.address.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address, "country", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "state"
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.state),
      expression: "entity.address.state"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "state",
      "type": "text",
      "placeholder": "Enter State"
    },
    domProps: {
      "value": (_vm.entity.address.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address, "state", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "city"
    }
  }, [_vm._v("City")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.city),
      expression: "entity.address.city"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "city",
      "type": "text",
      "placeholder": "Enter City"
    },
    domProps: {
      "value": (_vm.entity.address.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address, "city", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "zip"
    }
  }, [_vm._v("Zip code")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.zip),
      expression: "entity.address.zip"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "zip",
      "type": "text",
      "placeholder": "Enter Zip code"
    },
    domProps: {
      "value": (_vm.entity.address.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address, "zip", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "streetAddress1"
    }
  }, [_vm._v("Street Address 1")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.street1),
      expression: "entity.address.street1"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "streetAddress1",
      "type": "text",
      "placeholder": "Enter Street Address"
    },
    domProps: {
      "value": (_vm.entity.address.street1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address, "street1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "streetAddress2"
    }
  }, [_vm._v("Street Address 2")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.street2),
      expression: "entity.address.street2"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "streetAddress2",
      "type": "text",
      "placeholder": "Enter Street Address"
    },
    domProps: {
      "value": (_vm.entity.address.street2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address, "street2", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "mailCountry"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.mail_address.country),
      expression: "entity.mail_address.country"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "mailCountry",
      "type": "text",
      "placeholder": "Enter Country"
    },
    domProps: {
      "value": (_vm.entity.mail_address.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.mail_address, "country", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "mailState"
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.mail_address.state),
      expression: "entity.mail_address.state"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "mailState",
      "type": "text",
      "placeholder": "Enter State"
    },
    domProps: {
      "value": (_vm.entity.mail_address.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.mail_address, "state", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "mailCity"
    }
  }, [_vm._v("City")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.mail_address.city),
      expression: "entity.mail_address.city"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "mailCity",
      "type": "text",
      "placeholder": "Enter City"
    },
    domProps: {
      "value": (_vm.entity.mail_address.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.mail_address, "city", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "mailZip"
    }
  }, [_vm._v("Zip code")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.mail_address.zip),
      expression: "entity.mail_address.zip"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "mailZip",
      "type": "text",
      "placeholder": "Enter Zip code"
    },
    domProps: {
      "value": (_vm.entity.mail_address.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.mail_address, "zip", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "mailStreetAddress1"
    }
  }, [_vm._v("Street Address 1")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.mail_address.street1),
      expression: "entity.mail_address.street1"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "mailStreetAddress1",
      "type": "text",
      "placeholder": "Enter Street Address"
    },
    domProps: {
      "value": (_vm.entity.mail_address.street1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.mail_address, "street1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "mailStreetAddress2"
    }
  }, [_vm._v("Street Address 2")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.mail_address.street2),
      expression: "entity.mail_address.street2"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "mailStreetAddress2",
      "type": "text",
      "placeholder": "Enter Street Address"
    },
    domProps: {
      "value": (_vm.entity.mail_address.street2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.mail_address, "street2", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "altCountry"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.alt_address.country),
      expression: "entity.alt_address.country"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "altCountry",
      "type": "text",
      "placeholder": "Enter Country"
    },
    domProps: {
      "value": (_vm.entity.alt_address.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.alt_address, "country", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "altState"
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.alt_address.state),
      expression: "entity.alt_address.state"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "altState",
      "type": "text",
      "placeholder": "Enter State"
    },
    domProps: {
      "value": (_vm.entity.alt_address.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.alt_address, "state", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "altCity"
    }
  }, [_vm._v("City")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.alt_address.city),
      expression: "entity.alt_address.city"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "altCity",
      "type": "text",
      "placeholder": "Enter City"
    },
    domProps: {
      "value": (_vm.entity.alt_address.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.alt_address, "city", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "altZip"
    }
  }, [_vm._v("Zip code")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.alt_address.zip),
      expression: "entity.alt_address.zip"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "altZip",
      "type": "text",
      "placeholder": "Enter Zip code"
    },
    domProps: {
      "value": (_vm.entity.alt_address.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.alt_address, "zip", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "altStreetAddress1"
    }
  }, [_vm._v("Street Address 1")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.alt_address.street1),
      expression: "entity.alt_address.street1"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "altStreetAddress1",
      "type": "text",
      "placeholder": "Enter Street Address"
    },
    domProps: {
      "value": (_vm.entity.alt_address.street1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.alt_address, "street1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "altStreetAddress2"
    }
  }, [_vm._v("Street Address 2")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.alt_address.street2),
      expression: "entity.alt_address.street2"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "mailStreetAddress2",
      "type": "text",
      "placeholder": "Enter Street Address"
    },
    domProps: {
      "value": (_vm.entity.alt_address.street2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.alt_address, "street2", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "director"
    }
  }, [_vm._v("Director")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.director_name),
      expression: "entity.contacts.director_name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "director",
      "type": "text",
      "placeholder": "Enter Director Name"
    },
    domProps: {
      "value": (_vm.entity.contacts.director_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "director_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.phone1),
      expression: "entity.contacts.phone1"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "phone",
      "type": "text",
      "placeholder": "Enter Phone"
    },
    domProps: {
      "value": (_vm.entity.contacts.phone1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "phone1", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.phone2),
      expression: "entity.contacts.phone2"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "phone2",
      "type": "text",
      "placeholder": "Enter Phone 2"
    },
    domProps: {
      "value": (_vm.entity.contacts.phone2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "phone2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "fax"
    }
  }, [_vm._v("Fax")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.fax1),
      expression: "entity.contacts.fax1"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "fax",
      "type": "text",
      "placeholder": "Enter Fax"
    },
    domProps: {
      "value": (_vm.entity.contacts.fax1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "fax1", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.fax2),
      expression: "entity.contacts.fax2"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "fax2",
      "type": "text",
      "placeholder": "Enter Fax 2"
    },
    domProps: {
      "value": (_vm.entity.contacts.fax2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "fax2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "officeEmail"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.email1),
      expression: "entity.contacts.email1"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "officeEmail",
      "type": "text",
      "placeholder": "Enter Email"
    },
    domProps: {
      "value": (_vm.entity.contacts.email1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "email1", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.email2),
      expression: "entity.contacts.email2"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "officeEmail2",
      "type": "text",
      "placeholder": "Enter Email 2"
    },
    domProps: {
      "value": (_vm.entity.contacts.email2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "email2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "website"
    }
  }, [_vm._v("Website")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.website),
      expression: "entity.contacts.website"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "website",
      "type": "text",
      "placeholder": "Enter Website"
    },
    domProps: {
      "value": (_vm.entity.contacts.website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "website", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "directorEmail"
    }
  }, [_vm._v("Director Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.director_email),
      expression: "entity.contacts.director_email"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "directorEmail",
      "type": "text",
      "placeholder": "Enter Director Email"
    },
    domProps: {
      "value": (_vm.entity.contacts.director_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "director_email", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "googleLink"
    }
  }, [_vm._v("Google Maps link")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.location.gmap_link),
      expression: "entity.location.gmap_link"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "googleLink",
      "type": "text",
      "placeholder": "Enter Google Maps link"
    },
    domProps: {
      "value": (_vm.entity.location.gmap_link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.location, "gmap_link", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Geocode")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5",
    staticStyle: {
      "margin-bottom": "1rem"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.location.lat),
      expression: "entity.location.lat"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter latitude"
    },
    domProps: {
      "value": (_vm.entity.location.lat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.location, "lat", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.location.lng),
      expression: "entity.location.lng"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter longitude"
    },
    domProps: {
      "value": (_vm.entity.location.lng)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.location, "lng", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 offset-md-2"
  }, [(_vm.entity.location) ? _c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "350px",
      "margin-top": "20px"
    },
    attrs: {
      "center": _vm.mapCenter,
      "zoom": _vm.mapZoom
    },
    on: {
      "click": _vm.mapClick
    }
  }, [(_vm.entity.location.lat && _vm.entity.location.lng) ? _c('gmap-marker', {
    attrs: {
      "position": _vm.entityMapCenter
    }
  }) : _vm._e()], 1) : _vm._e()], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Office has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create Branch Office of Research Center")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")]), _vm._v(" "), _c('div', {
    staticClass: "card-collapse"
  }, [_vm._v("Collapse")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Address")]), _vm._v(" "), _c('div', {
    staticClass: "card-collapse"
  }, [_vm._v("Collapse")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Mail Address")]), _vm._v(" "), _c('div', {
    staticClass: "card-collapse"
  }, [_vm._v("Collapse")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Alternative Address")]), _vm._v(" "), _c('div', {
    staticClass: "card-collapse"
  }, [_vm._v("Collapse")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Contact info")]), _vm._v(" "), _c('div', {
    staticClass: "card-collapse"
  }, [_vm._v("Collapse")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Location")]), _vm._v(" "), _c('div', {
    staticClass: "card-collapse"
  }, [_vm._v("Collapse")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ea5a1e4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/branchOffices/New.vue
// module id = 970
// module chunks = 0